import { ArrowDownIcon, ArrowRightIcon } from '../../../../common/ui/icons';
import { IGalleryAlbum } from '../../gallery-interfaces';
import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { NavLink, useParams } from 'react-router-dom';
import DragAlbumBtn from './drag/drag-album-btn';
import { closeGalleryAlbum, openGalleryAlbum } from '../../domain/gallery-storage';
import { useGalleryStore } from '../../data/gallery-store';

interface IGalleryMenuItemTitleProps {
    album: IGalleryAlbum;
}

const GalleryMenuItemTitle = ({ album } : IGalleryMenuItemTitleProps) => {

    const { album_id } = useParams();

    const galleryAlbums = useGalleryStore(store => store.galleryAlbums);
    const setGalleryAlbums = useGalleryStore(store => store.setGalleryAlbums);

    const hasNestedItems = album?.nested.length > 0;

    const toggleAlbum = () => {

        if(album.isOpened) {
            closeGalleryAlbum(album.album_id);
        }
        else{
            openGalleryAlbum(album.album_id);
        }

        album.isOpened = !album.isOpened;

        try{
            const albums = JSON.parse(JSON.stringify(galleryAlbums));
            setGalleryAlbums(albums);
        }
        catch (ex) {
            console.log(ex);
        }
    };

    return (
        <div className="gallery__menu-item__title flex items-center flex-1">
            {
                hasNestedItems &&
                <button type="button" onClick={ toggleAlbum }>
                    { album.isOpened && <ArrowDownIcon color={ '#94A3B8' } /> }
                    { !album.isOpened && <ArrowRightIcon color={ '#94A3B8' } /> }
                </button>
            }

            {/* Only to keep the same space */}
            {
                !hasNestedItems &&
                <>
                    <div className="relative">
                        <button type="button" className="invisible">
                            <ArrowRightIcon color={ '#88a3d0' } />
                        </button>
                        <div className="h-px absolute bg-slate-700 left-0 w-3/6 top-1/2" />
                    </div>
                </>
            }

            <NavLink
                to={ `/gallery/${ album.album_id }` }
                className="gallery__menu-item__title text-left flex-1"
                onClick={ closeMobileMenu }>
                { album.album_title }
                { hasNestedItems && <span className="text-slate-400"> ({ album.nested.length }) </span> }
            </NavLink>

            {
                album_id === album.album_id.toString() &&
                <DragAlbumBtn album={ album }/>
            }

        </div>
    )
};

export default GalleryMenuItemTitle;